import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../services/api";
import {BaseBackEND}  from "../services/auth"
import {Helmet} from 'react-helmet'
import Whatsapp from "../assets/img/icon/whatsapp.png"


import HeaderUser from "./content/header";
import Footer from "./content/footer"


import AllCoursesIndex from "./content/allcourses"

class Posgraduacao extends Component {

    state = {
        configuracao:[],
        assunto:null,
        nome:null,
        mensagem:null,
        email:null,
        btn:"Enviar Mensagem"

    }

    async componentDidMount(){
        const response = await api.post("/configuracao/show");
        this.setState({ configuracao: response.data
         });
         
    
      }
    

    onFormSubmit = async e =>{
        e.preventDefault() ;
        this.setState({ btn: "Carregando"
        });
        const { nome,assunto, mensagem,email} = this.state;
        if (!nome || !assunto || !mensagem || !email ) {
            this.setState({ error: "Preencha os campos antes de enviar!",
            success:null });
            this.setState({ btn: "Enviar Mensagem"
            });
        } else {
        const response = await api.post("/contatenos", {  nome,assunto, mensagem,email });
        

            if(response.data.success){
            this.setState({ success: "Mensagem Enviada" , error:null,
            btn: "Mensagem Enviada!"
            });
            }

        }
    }

  render() {
    return (
      <React.Fragment>
        <HeaderUser />
       
       
<div class="container">
        
<section class="mb-4">

   
    <h2 class="h1-responsive font-weight-bold text-center my-4">Possui dúvidas? 
    <a target="_blank" href={"http://api.whatsapp.com/send?phone=55"+this.state.configuracao.whatsapp+"&text="+this.state.configuracao.whatsapptext}>
            <img src={Whatsapp} class="ico-whatsapp" width="40" height="40" />
          </a></h2>
    

    <p class="text-center w-responsive mx-auto mb-5">Preencha o formulário com as suas dúvidas e questões, responderemos o mais breve possível.</p>
    
    <center>   {this.state.error && <p><b>{this.state.error}</b></p>}
        {this.state.success && <p><b>{this.state.success}</b></p>}</center>
    <div class="row">
  
       
        <div class="col-md-9 mb-md-0 mb-5">
            <form id="contact-form" name="contact-form" onSubmit={this.onFormSubmit}>

               
                <div class="row">

                    
                    <div class="col-md-6">
                        <div class="md-form mb-0">
                            <input type="text" id="name" name="name" class="form-control" onChange={e => this.setState({ nome: e.target.value })} />
                            <label for="name" class="" >Seu Nome</label>
                        </div>
                    </div>
                   

                  
                    <div class="col-md-6">
                        <div class="md-form mb-0">
                            <input type="text" id="email" name="email" class="form-control" onChange={e => this.setState({ email: e.target.value })} />
                            <label for="email" class="" >Seu E-mail</label>
                        </div>
                    </div>
                  

                </div>
                

                <div class="row">
                    <div class="col-md-12">
                        <div class="md-form mb-0">
                            <input type="text" id="subject" name="subject" class="form-control" onChange={e => this.setState({ assunto: e.target.value })} />
                            <label for="subject" class="" >Assunto</label>
                        </div>
                    </div>
                </div>

                <div class="row">


                    <div class="col-md-12">

                        <div class="md-form">
                            <textarea type="text" onChange={e => this.setState({ mensagem: e.target.value })} id="message" name="message" rows="2" class="form-control md-textarea"></textarea>
                            <label for="message">Sua Mensagem</label>
                        </div>

                    </div>
                </div>


           

            <div class="text-center text-md-left">
                <button type="submit" class="btn btn-primary" >{this.state.btn}</button>
            </div>
            </form>
            <div class="status">

            </div>
        </div>
    


        <div class="col-md-3 text-center">
            <ul class="list-unstyled mb-0">
                <li><i class="fas fa-map-marker-alt fa-2x"></i>
                <p>{this.state.configuracao.endereco}</p>
                </li>

                <li><i class="fas fa-phone mt-4 fa-2x"></i>
                    <p>{this.state.configuracao.telefone}</p>
                </li>
               

                <li><i class="fas fa-envelope mt-4 fa-2x"></i>
                <p>{this.state.configuracao.email}</p>
                </li>
            </ul>
        </div>
      

    </div>

</section>
</div>
      
      <Footer />
      </React.Fragment>
       
    );
  }
}

export default withRouter(Posgraduacao);


// WEBPACK FOOTER //
// ./src/pages/contateus.js